import { Play, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const CHANNEL = "https://www.youtube.com/@hydeparkvictorychurch7384";

const SERMONS = [
  { title: "Sunday Worship Replay", tag: "Sundays", desc: "Catch the full Sunday morning worship experience anytime." },
  { title: "WED 3for30 Bible Study", tag: "Wednesdays", desc: "Midweek teaching with practical application of God's Word." },
  { title: "Prayer & Devotion", tag: "Weekly", desc: "Moments of prayer and encouragement to carry you through the week." },
];

export default function Sermons() {
  return (
    <section id="sermons" data-testid="sermons-section" className="relative py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-wrap items-end justify-between gap-8">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-[#4169E1] mb-6">Watch & Listen</p>
            <h2 className="font-display font-bold uppercase tracking-tighter leading-none text-4xl sm:text-5xl md:text-6xl">
              Sermons
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <a
              data-testid="sermons-youtube-cta"
              href={CHANNEL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 border border-white/20 hover:border-[#4169E1] text-white font-semibold uppercase tracking-widest text-sm px-8 py-4 rounded-sm transition-colors duration-300 hover:-translate-y-0.5"
            >
              YouTube Channel
              <ArrowUpRight className="w-4 h-4 text-[#4169E1]" />
            </a>
          </Reveal>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8">
          {SERMONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.1}>
              <a
                data-testid={`sermon-card-${i}`}
                href={CHANNEL}
                target="_blank"
                rel="noopener noreferrer"
                className="group block h-full bg-[#111] border border-white/10 rounded-sm p-10 hover:border-[#4169E1]/40 hover:-translate-y-1 transition-[transform,border-color] duration-500"
              >
                <div className="flex items-center justify-between mb-10">
                  <span className="text-xs uppercase tracking-[0.3em] text-zinc-500">{s.tag}</span>
                  <span className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center group-hover:bg-[#4169E1] group-hover:border-[#4169E1] transition-colors duration-500">
                    <Play className="w-4 h-4 text-white ml-0.5" />
                  </span>
                </div>
                <h3 className="font-display font-semibold uppercase tracking-tight text-2xl mb-4">{s.title}</h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
